// src/main.tsx
// App entry point. Bootstraps the React app, global styles,
// i18n, and the router.

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "./index.css";
import "./i18n"; // Initializes i18next
import { App } from "./App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Per BENCHMARK's cost-saving approach: don't refetch on focus
      refetchOnWindowFocus: false,
      // Retry once before failing
      retry: 1,
      // 30 sec stale time
      staleTime: 30 * 1000,
    },
  },
});

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element not found");
}

createRoot(rootElement).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);